import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './styles/home.css';

// === IMPORT COMPONENTS ===
import TickerCarousel from './components/TickerCarousel';
import ToolsSection from './components/ToolsSection';
import HostingPanelBlocks from './components/HostingPanelBlocks';
import WorldMapRegions from './components/WorldMapRegions'; 
import MoreTrust from './components/MoreTrust';// ✅ NEW IMPORT


const Home = () => {
  // === FAQ LOGIC ===
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqItems = [
  {
    question: 'What is a Hostname I see during the order process of a VPS product?',
    answer: `A hostname is the name that identifies your server on the internet or within a network. It must always be a Fully Qualified Domain Name (FQDN) — which means it includes both a subdomain and a domain.'<br><br>
A hostname for a Virtual Private Server will always begin getting setup with a hostname (FQDN). Therefore, yourserver will always have a sub-domain and a fully qualified domain name (FQDN), like this:<br><br>
youpick.yourdomain.com<br>
example.i-word.net<br>
myserver.yourdomain.net<br><br>
Then when you start setting up your server from SSH Command line you do this first and foremost:<br><br>
sudo hostnamectl set-hostname youpick.yourdomain.com<br><br>
That's it. You just set your web servers hostname.`
  },
  {
    question: 'How do I choose what regions/locations to locate my server?',
    answer: `You can easily select your server location from the drop down during checkout.`
  },
  {
    question: 'How to Register a New Domain?',
    answer: `You can register a new domain directly through the #1 domain search on the W3 here at Iword. More details here: <a href="https://account.i-word.net/plugin/support_manager/knowledgebase/view/41/how-to-register-a-new-domain/6/" target="_blank" rel="noopener noreferrer">this article for further details</a>.`
  },
  {
    question: 'How to Point a Domain to Your Hosting Plan?',
    answer: `To make your website live, you’ll need to update your domain’s nameservers to point to our hosting system. More details here: <a href="https://account.i-word.net/plugin/support_manager/knowledgebase/view/4/how-to-point-a-domain-to-your-hosting-plan/1/" target="_blank" rel="noopener noreferrer">this article for further details</a>`
  },
  {
    question: 'Why Are My Emails Going to Spam?',
    answer: `Spam filters look at many signals to decide whether to deliver, block, or junk an email. If your emails are landing in spam, check the following: More details here: <a href="https://account.i-word.net/plugin/support_manager/knowledgebase/view/48/why-are-my-emails-going-to-spam/8/" target="_blank" rel="noopener noreferrer">this article for further details</a>`
  },
  {
    question: 'Common WordPress Errors and How to Fix Them?',
    answer: `These errors are usually caused by misconfigured plugins, themes, or database issues. More details here: <a href="https://account.i-word.net/plugin/support_manager/knowledgebase/view/17/common-wordpress-errors-and-how-to-fix-them-html-copy/3/" target="_blank" rel="noopener noreferrer">this article for further details</a>`
  },
  {
    question: 'What is a Content Delivery Network (CDN)?',
    answer: `Enabling Caching and CDN for Better Speed and Exponential security is a must. More details here: <a href="https://account.i-word.net/plugin/support_manager/knowledgebase/view/18/enabling-caching-and-cdn-for-better-speed/3/" target="_blank" rel="noopener noreferrer">this article for further details</a>`
  },
  {
    question: 'I purchased a VPS Server. How to access my Command Console?',
    answer: `We strongly reccomend using the following for best practices. More details here: <a href="https://account.i-word.net/plugin/support_manager/knowledgebase/view/19/how-to-access-your-vps-via-ssh/4/" target="_blank" rel="noopener noreferrer">this article for further details</a>`
  }
];

  return (
    <>
      {/* === HERO SECTION === */}
      <section className="hero">
        <div className="hero-inner">
          <div className="hero-left">
            <span className="hero-badge">SAVE 92%</span>
            <h2 className="hero-title">
              Build from 12 operating systems, 100+ applications,
              via top-tier Datacenter's in 32 regions!
            </h2>
            <p className="hero-subtext">From $0.99/mo</p>
            <div className="hero-buttons">
              <Link to="/cpanel" className="hero-button">Get Started</Link>
              <div className="hero-note">Free Backups, Migrations & SSL. ✅</div>
            </div>
          </div>
          <div className="hero-right">
            <img
              src="/images/hero-right.png"
              alt="Hero Illustration"
              className="hero-illustration"
            />
          </div>
        </div>
      </section>
      {/* === End Hero Section === */}

      {/* === CTA SECTION === */}
      <section className="cta-section">
        <div className="cta-inner">
          <h2 className="cta-title">Get Started With High Speed WordPress Hosting</h2>
          <Link to="/wordpress" className="cta-button">See Pricing</Link>
          <p className="cta-guarantee">
            <span className="check">✔</span> 30 Days Money Back Guarantee
          </p>
        </div>
      </section>
      {/* === End CTA Section === */}

      {/* === GLOBAL DATA CENTERS SECTION === */}
      <section className="global-section">
        <div className="global-inner">
          <div className="global-left">
            <div className="global-image-wrapper">
              <img
                src="/images/datacenter.svg"
                alt="Global Data Centers"
                className="global-image"
              />
            </div>
          </div>
          <div className="global-right">
            <h2 className="global-title">Global Data Centers 20+ countries</h2>
            <p className="global-text">
              Host your website where it matters most. With direct connections to the internet’s backbone,
              our data centers deliver blazing-fast performance, low latency, and military-grade security.
            </p>
            <ul className="global-features">
              <li><span className="check">✔</span> Ultra-low latency worldwide</li>
              <li><span className="check">✔</span> Military-grade physical security</li>
              <li><span className="check">✔</span> Green, energy-efficient infrastructure</li>
            </ul>
          </div>
        </div>
      </section>
      {/* === End Global Data Centers Section === */}

      {/* === WORLD MAP SECTION === */}
      <WorldMapRegions />
      {/* === End World Map Section === */}

      {/* === TICKER CAROUSEL SECTION === */}
      <section className="ticker-section">
        <TickerCarousel />
      </section>
      {/* === End Ticker Carousel Section === */}

      {/* === TOOLS SECTION === */}
      <section className="tools-section">
        <ToolsSection />
      </section>
      {/* === End Tools Section === */}

      {/* === HOSTING PANELS SECTION === */}
      <section className="hosting-panels-section">
        <HostingPanelBlocks />
      </section>
      {/* === End Hosting Panels Section === */}

      {/* === FAQ SECTION === */}
<section className="faq-section">
  <div className="faq-container">
    <h2 className="faq-title">Frequently Asked Questions (FAQs)</h2>
    <p className="faq-updated">Updated on 12 June, 2025</p>
    <p className="faq-intro">
      These are the frequently asked questions for Iword Hosting.
    </p>

    <div className="faq-accordion">
      {faqItems.map((item, index) => (
        <div className={`faq-item ${openIndex === index ? 'open' : ''}`} key={index}>
          <button className="faq-question" onClick={() => toggleFaq(index)}>
            <span>{item.question}</span>
            <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
          </button>
          {openIndex === index && (
            <div className="faq-answer">
              <p dangerouslySetInnerHTML={{ __html: item.answer }} />
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
</section>
{/* === End FAQ SECTION === */}
{/* === MORE TRUST SECTION === */}
<MoreTrust />
{/* === End More Trust Section === */}
    </>
  );
};

export default Home;
